import { BrowserModule } from "@angular/platform-browser";
import { NgModule, LOCALE_ID } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { RouterModule, Routes } from "@angular/router";
import { Ng2Webstorage } from "ngx-webstorage";

import { ServiceService } from "./services/service.service";

import { SafeHtmlPipe } from "./pipe/SafeHtmlPipe";
import { NewLinePipe } from "./pipe/NewLinePipe";

import { AppComponent } from "./app.component";
import { LoginComponent } from "./components/login/login.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { WellcomeComponent } from "./components/wellcome/wellcome.component";
import { SoalComponent } from "./components/soal/soal.component";
import { LogoutComponent } from "./components/logout/logout.component";
import { QuisionerComponent } from "./components/quisioner/quisioner.component";
import { SkorComponent } from "./components/skor/skor.component";

const appRoutes: Routes = [
	{ path: "", component: LoginComponent },
	{ path: "dashboard", component: DashboardComponent },
	{ path: "soal", component: SoalComponent },
	{ path: "quisioner", component: QuisionerComponent },
	{ path: "skor", component: SkorComponent },
	{ path: "logout", component: LogoutComponent }
];

@NgModule({
	declarations: [
		AppComponent,
		LoginComponent,
		DashboardComponent,
		WellcomeComponent,
		SoalComponent,
		LogoutComponent,
		QuisionerComponent,
		SkorComponent,
		SafeHtmlPipe,
		NewLinePipe
	],
	imports: [
		BrowserModule,
		Ng2Webstorage,
		HttpModule,
		ReactiveFormsModule,
		RouterModule.forRoot(appRoutes)
	],
	providers: [
		{ provide: LOCALE_ID, useValue: "id-ID" }, //replace "en-US" with your locale
		ServiceService
	],
	bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts